import firebase from "firebase/app";
import { tAdminUserState } from "./types";
export const kDefaultUser: tAdminUserState = {
  accountType: "none",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  customerId: 0,
  uid: "",
  userName: "",
  userTitle: "",
  avatar: "",
  companyRefPath: "",
  role: "",
  accountScope: "",
  dateJoined: firebase.firestore.Timestamp.now(),
};
